import TreshIcon from './component'

export default TreshIcon
